import styled from "styled-components";

const PromoteMemberContainer = styled.div`

`;

export default PromoteMemberContainer;